<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Rename folder</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || isSameName"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <Input
        v-model="name"
        size="xl"
        label="Folder name"
        :error="error"
        :disabled="loading"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import type { Folder } from '@/shared/graphql/router/graphql'
import { useRenameFolder } from './useRenameFolder'

const { close } = useSheet()

const props = defineProps<{
  item: Folder
}>()

const { name, error, loading, isSameName, save } = useRenameFolder(props.item)

const handleSave = async () => {
  if (await save()) close()
}
</script>
